import type { ReactNode } from 'react';

import { Sidebar } from './Sidebar';
import { Topbar } from './Topbar';
import styles from './AdminShell.module.css';

interface AdminShellProps {
  children: ReactNode;
}

// PARA-106 §3 (UI-архитектура) — layout-shell: Sidebar + Topbar + текущая страница.
export function AdminShell({ children }: AdminShellProps): JSX.Element {
  return (
    <div className={styles.shell}>
      <Sidebar />
      <div className={styles.panel}>
        <Topbar />
        <main className={styles.scroll}>
          <div className={styles.content}>{children}</div>
        </main>
      </div>
    </div>
  );
}
